var exports = {
  "$T": "Notice__nIRHE5",
  "QB": "Message___iPPH6",
  "$D": "Error__T1SQtt",
};

module.exports = exports;
